import { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { PORTAL_ENABLED } from '../lib/feature-flags';

const NAV = [
  { to: '/',           label: 'Home', end: true },
  { to: '/services',   label: 'Services' },
  { to: '/regulatory', label: 'Regulatory' },
  { to: '/about',      label: 'About' },
  { to: '/contact',    label: 'Contact' },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  // Close menu on route change.
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  // Lock body scroll while the mobile menu is open.
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  // Close on Escape.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    // Fragment — the mobile-nav panel sits as a SIBLING of <header> so it
    // escapes the header's backdrop-filter stacking context. Otherwise z-index
    // on the panel can never beat sibling page content like the hero.
    <>
      <header className="site-hd">
        <div className="container inner">
          <Link to="/" aria-label="Omega Trade home"><Logo /></Link>

          <nav className="site-hd-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                {n.label}
              </NavLink>
            ))}
            {PORTAL_ENABLED && (
              <Link className="btn accent sm" to="/sign-in">Log in / Register</Link>
            )}
          </nav>

          <button
            type="button"
            className={`hamburger${open ? ' on' : ''}`}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            aria-controls="site-hd-mobile"
            onClick={() => setOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      <div
        id="site-hd-mobile"
        className={`mobile-nav${open ? ' on' : ''}`}
        hidden={!open}
      >
        <nav>
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              {n.label}
            </NavLink>
          ))}
          {PORTAL_ENABLED && (
            <Link className="btn accent" to="/sign-in">Log in / Register</Link>
          )}
        </nav>
      </div>
    </>
  );
}
